import { render, staticRenderFns } from "./PWAPromptForm.vue?vue&type=template&id=1522af44&scoped=true"
import script from "./PWAPromptForm.vue?vue&type=script&lang=js"
export * from "./PWAPromptForm.vue?vue&type=script&lang=js"
import style0 from "./PWAPromptForm.vue?vue&type=style&index=0&id=1522af44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522af44",
  null
  
)

export default component.exports